import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";
import { PageResponse } from "app/common/Model/Shared";
import { pagingPatientTransaction } from "app/services/PatientTransaction";
import { VOUCHER_INVOICE_HISTORY_DEPOSIT } from "app/common/LocalConst";

const DEFAULT_SEARCH = {
  transactionCategory: VOUCHER_INVOICE_HISTORY_DEPOSIT,
  fromDate: new Date(new Date().getFullYear(), 0, 1),
  toDate: new Date(),
};
export default class HistoryDepositStore {
  searchHistoryDeposit = {
    ...new SearchObject(),
    ...DEFAULT_SEARCH,
  };
  pageHistoryDeposit = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  pagingHistoryDeposit = async () => {
    return await pagingPatientTransaction(this.searchHistoryDeposit)
      .then(({ data }) => {
        this.pageHistoryDeposit = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tiền cọc có lỗi");
      });
  };

  handleChangeFormSearch = (searchHistoryDeposit) => {
    this.searchHistoryDeposit = {
      ...this.searchHistoryDeposit,
      ...searchHistoryDeposit,
    };
    this.pagingHistoryDeposit();
  };

  resetStore = () => {
    this.searchHistoryDeposit = {
      ...new SearchObject(),
      ...DEFAULT_SEARCH,
    };
    this.pageHistoryDeposit = new PageResponse();
  };
}
